import React, { useEffect, useState } from 'react'
import { init } from 'shareon'
import 'shareon/css' // most bundlers will transpile this CSS

interface ShareOnModalProps {
  url: string
  title: string
  onClose: () => void
}

const ShareOnModal = ({ url, title, onClose }: ShareOnModalProps) => {
  const [linkCopied, setLinkCopied] = useState(false)
  useEffect(() => {
    if (url) {
      console.log('init shareon')

      init()
    }
  }, [url])

  return (
    <div
      id="share-post-modal"
      className="modal"
      style={{ display: url ? 'block' : 'none' }}
    >
      <div id="share-post-modal-content" className="modal-content">
        <span
          id="share-post-modal-close"
          className="close"
          onClick={() => {
            setLinkCopied(false)
            onClose()
          }}
        >
          &times;
        </span>
        <span id="share-post-modal-title">Share post</span>
        {linkCopied && (
          <span id="share-post-modal-link-copied" style={{ display: 'inline' }}>
            Link copied!
          </span>
        )}
        <div
          className="shareon"
          data-url={url}
          data-title={`Read my blog on Explore with Imray: ${title}`}
        >
          <a className="facebook"></a>
          <a className="twitter"></a>
          <a className="whatsapp"></a>
          <a
            id="share-link"
            onClick={() => {
              console.log('copying link', url)

              navigator.clipboard.writeText(url)
              setLinkCopied(true)
            }}
          >
            <span className="material-icons">link</span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default ShareOnModal
